export const isFeatureActive = (state, key) => Boolean(state.config.features[key]);
export const hasVariant = (state, key, variant) => state.config.experiments[key] === variant;
export const whichVariant = (state, key) => state.config.experiments[key];
